import { ParamsService } from '../services'

const uploadCategoriasDelitos = (formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await ParamsService.uploadCategoriasDelitos(formData)
      resolve(response)
    } catch (error) {
      reject({ error: true, message: error.response.data || error.message, code: error.response.status })
    }
  })
}

export default uploadCategoriasDelitos 